// Mock data for Tarot Card Reading Website

export const siteInfo = {
  readerName: "Tarot Card Reading",
  brandName: "Tarot Reader Tejashvini",
  tagline: "Discover Clarity, Guidance & Empowerment",
  description: "Tarot is a powerful tool for introspection, exploring the subconscious mind, gaining insights into the past, present, and future.",
  experience: "6 Years",
  languages: ["English", "Hindi"],
  email: "bathejatejashvini@gmail.com",
  social: {
    tiktok: "https://www.tiktok.com/@tejashvini.batheja?_r=1&_t=ZN-93BqlypD63y",
    youtube: "https://youtube.com/@divinedecode09?si=Vx09duXwMiNSsM4Q"
  },
  workingHours: "Mon-Fri, 9:00 AM - 5:00 PM EST"
};

export const services = [
  {
    id: 4,
    title: "Predictions Only Session",
    type: "Live Interaction",
    description: "10-minute Zoom Reading, or TikTok Live Mini Reading.",
    icon: "Video",
    features: [
      "10-min Zoom reading or TikTok Live mini reading",
      "Interactive Q&A Session",
      "Real-time personalized insights",
      "Flexible timing",
      "Great for a quick focused question"
    ]
  },
  {
    id: 1,
    title: "Delivered Readings",
    type: "Written Guidance",
    description: "Get your questions answered through detailed written tarot readings delivered via email. Ideal for those who prefer to reflect on guidance at their own pace.",
    icon: "Mail",
    features: [
      "Predictions, guidance, counseling & remedies",
      "Angel guidance & love messages",
      "Written responses & clear insights",
      "2 follow-up questions included",
      "Delivered within 48 hours"
    ]
  },
  {
    id: 2,
    title: "1:1 Zoom Readings",
    type: "Interactive Session",
    description: "Real-time tarot reading sessions via Zoom audio call, offering interactive and personalized guidance for your questions and concerns.",
    icon: "Phone",
    features: [
      "Predictions, guidance, counselling and remedies",
      "Angel guidance & love messages",
      "Immediate clarity through live interaction",
      "3 follow-up questions included",
      "Flexible scheduling"
    ]
  },
  {
    id: 3,
    title: "Aura Scanning",
    type: "Energy Report",
    description: "A personalized energy assessment that provides a comprehensive report on your overall energy field.",
    icon: "Sparkles",
    features: [
      "Overview of your energy field",
      "Assessment of all seven chakras",
      "Nazar Dosh & Bandhan / bonding Dosh detection",
      "Remedies suggested if required",
      "Report delivered within 72 hours"
    ]
  }
];

export const pricingPackages = [
  {
    id: 1,
    type: "Delivered Readings",
    bgColor: "#D987FF",
    textColor: "#000000",
    packages: [
      { questions: "3 Questions", popular: false },
      { questions: "5 Questions", popular: true }
    ]
  },
  {
    id: 2,
    type: "Live Consultation",
    bgColor: "#88A2FF",
    textColor: "#000000",
    packages: [
      { duration: "20 Minutes", popular: false },
      { duration: "40 Minutes", popular: true }
    ]
  },
  {
    id: 3,
    type: "Aura Scanning",
    bgColor: "#FFD1E7",
    textColor: "#000000",
    packages: [
      { service: "Complete Aura Reading", popular: true }
    ]
  },
  {
    id: 4,
    type: "Predictions Only Session",
    bgColor: "#FF8A65",
    textColor: "#000000",
    packages: [
      { service: "Predictions Only Session", popular: true }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    text: "Hey Tejashvini, it's been a few months since our session, and I can't believe how accurate everything you said was! Thank you for your guidance—it really helped me stay on track."
  },
  {
    id: 2,
    text: "I was surprised by how accurate the chakra and energy report was. Your guidance helped me focus on areas I'd been neglecting and brought positive changes in my daily life."
  },
  {
    id: 3,
    text: "hey! I just love your readings so much. It really helped me alot with all my anxiety stuff. I haven't seen my self with so much patience for a while but now i do. It really helped me to make a best decision for myself!!! Thanks a lot I really appreciate your efforts."
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is tarot reading and how does it work?",
    answer: "Tarot is a powerful tool for introspection and gaining insights into your past, present, and future. The cards serve as mirrors to your subconscious, revealing patterns, energies, and potential outcomes. It's important to understand that tarot reveals the most probable outcome based on your current path and circumstances."
  },
  {
    id: 2,
    question: "What type of questions can I ask?",
    answer: "You can ask about career, relationships, personal growth, spiritual development, and life decisions. However, the following topics will not be predicted or discussed under any circumstances: Death or timing of death, Critical or life-threatening health conditions, Medical diagnoses or treatment advice, Baby's gender prediction."
  },
  {
    id: 3,
    question: "How should I prepare for my reading?",
    answer: "Be specific with your questions and open about your concerns. Think about what you truly want guidance on. It's helpful to be in a calm, receptive state of mind. You can consult with me before the session if you need assistance formulating your questions."
  },
  {
    id: 4,
    question: "How long does it take to receive a delivered reading?",
    answer: "Delivered readings are typically completed within 48 hours of receiving your payment and required information. You'll receive a detailed written response via email with interpretations of the cards drawn for your questions."
  },
  {
    id: 5,
    question: "What payment methods do you accept?",
    answer: "I accept payments via PayPal. Advance payment is required to confirm your session booking. You'll receive booking confirmation once payment is received."
  },
  {
    id: 6,
    question: "Can I reschedule my session?",
    answer: "If you have an emergency, you may reschedule your session via email at least 24 hours in advance. Only one reschedule is allowed per booking. If the reader must cancel due to an emergency, you may choose to either reschedule the session to a new date and time, or receive a full refund."
  },
  {
    id: 7,
    question: "Are emergency slots available?",
    answer: "No priority slot. Only emergency slot to be booked 24 hours in advance with 30% extra charges. Please contact me via email to arrange emergency booking."
  },
  {
    id: 8,
    question: "Is my information kept confidential?",
    answer: "Absolutely. I uphold the highest standards of confidentiality. All information shared during consultations is kept strictly private. I create a safe space for vulnerability and trust."
  }
];

export const images = {
  backgrounds: {
    cosmic: "https://images.pexels.com/photos/3262249/pexels-photo-3262249.jpeg",
    eclipse: "https://images.unsplash.com/photo-1509978778156-518eea30166b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjb3NtaWMlMjBzcGlyaXR1YWwlMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc2OTU5NjA0NHww&ixlib=rb-4.1.0&q=85",
    milkyway: "https://images.pexels.com/photos/1376766/nature-milky-way-galaxy-space-1376766.jpeg"
  }
};